import { AfterViewInit, Component, DestroyRef, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { LoadingOptions } from '../../../../../models/shared/loading-options';
import { PortalService } from '../../../../../services/portal/portal.service';
import { ResetPasswordViewModel } from './reset-password-view-model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonTypeEnum } from '../../../../../ui/buttons/button/button-type.enum';
import { take } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { ResetPasswordRequest } from '../../../../../models/users/requests/reset-password-request';
import { TextInputComponent } from '../../../../../ui/form-components/text-input/text-input.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  providers: [ResetPasswordViewModel],
  styleUrls: ['./reset-password.component.scss', '../auth.component.scss']
})
export class ResetPasswordComponent implements AfterViewInit {
  private viewModel = inject(ResetPasswordViewModel);
  private portalService = inject(PortalService);
  private destroyRef = inject(DestroyRef);

  @Output() loadingOpts = new EventEmitter<LoadingOptions>();

  @ViewChild('codeInput', { static: true }) codeInput!: TextInputComponent;

  private listenToLoadingOpts = this.viewModel.loadingOpts$
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(opts => this.loadingOpts.emit(opts));

  public formSubmitted: boolean = false;

  public formGroup$ = this.viewModel.formGroup$;

  public customErrorMessages = {
    email: {
      required: $localize`Email is required`,
      email: $localize`Invalid email address`
    },
    code: {
      required: $localize`Code is required`
    },
    newPassword: {
      required: $localize`New password is required`,
      passwordComplexity: $localize`Password does not meet requirements`
    },
    confirmPassword: {
      required: $localize`Confirm password is required`,
      fieldsMustMatch: $localize`Passwords must match`
    }
  };

  public ngAfterViewInit(): void {
    this.codeInput.input.nativeElement.focus();
  }

  public resetPassword(): void {
    this.formSubmitted = true;
    combineLatest([this.formGroup$, this.portalService.portalType$])
      .pipe(take(1))
      .subscribe(([fg, portalType]) => {
        if (fg.valid) {
          const { email, code, newPassword } = fg.getRawValue();
          const req = new ResetPasswordRequest(email, code, newPassword);
          this.viewModel.resetPassword(req, portalType);
        }
      });
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
